<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable i18next/no-literal-string -->
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div
    class="mc-sidebar-liveview__fleet mc-trackvision-live-streaming__list-fleet-v2"
    :class="{ 'search-active': !!search }"
  >
    <div>
      <div
        class="mc-sidebar-liveview__search-wrapper mc-trackvision-live-streaming__search-action-wrapper"
      >
        <div class="mc-trackvision-live-streaming__search-wrapper">
          <b-input-group class="mc-sidebar-liveview__search" @click="focusSearch">
            <template #prepend>
              <b-input-group-text>
                <i class="icon-outline_search"></i>
              </b-input-group-text>
            </template>
            <b-form-input
              ref="searchInput"
              type="search"
              :placeholder="`${$t('global.search')}...`"
              :disabled="$store.state.video.loadingFleets || isLoadingMore"
              @input="handleSearch"
            />
          </b-input-group>
        </div>

        <div class="d-flex align-items-center mc-trackvision-live-streaming__action-wrapper">
          <b-button
            variant="outline-primary"
            class="btn-sort-filter"
            :disabled="$store.state.video.loadingFleets || isLoadingMore"
            @click="handleClickFilterLiveStream"
          >
            <i class="mc-fa icon-outline_filter"></i>
            <span v-if="filterActive" class="badge-active"></span>
          </b-button>
          <b-button
            id="sortFleetBtn"
            class="btn-sort-filter"
            variant="outline-primary"
            :disabled="$store.state.video.loadingFleets || isLoadingMore"
            @click="clickSort"
          >
            <i class="mc-fa icon-fill_height"></i>
            <span v-if="orderActive !== null" class="badge-active"></span>
          </b-button>
          <b-popover
            id="sortFleet"
            ref="popover"
            target="sortFleetBtn"
            triggers="click blur"
            :show.sync="sortPopover"
            placement="leftbottom"
          >
            <b-list-group class="mc-list-group-item">
              <b-list-group-item
                :active="orderActive == 1 ? true : false"
                :disabled="$store.state.video.loadingFleets"
                @click="sortBy('licensePlate', 'asc', 1)"
              >
                {{ $t('global.object.licensePlate') }}: A-Z
              </b-list-group-item>
              <b-list-group-item
                :active="orderActive == 2 ? true : false"
                :disabled="$store.state.video.loadingFleets"
                @click="sortBy('licensePlate', 'desc', 2)"
              >
                {{ $t('global.object.licensePlate') }}: Z-A
              </b-list-group-item>
              <b-list-group-item
                :active="orderActive == 3 ? true : false"
                :disabled="$store.state.video.loadingFleets"
                @click="sortBy('calculatedMotionStatus', 'asc', 3)"
              >
                {{ $t('global.object.fleetStatus') }}: {{ $t('global.filter.running') }}
              </b-list-group-item>
              <b-list-group-item
                :active="orderActive == 4 ? true : false"
                :disabled="$store.state.video.loadingFleets"
                @click="sortBy('videoStatus', 'asc', 4)"
              >
                Status Video: Online
              </b-list-group-item>
            </b-list-group>
          </b-popover>

          <b-button
            variant="outline-primary"
            :class="!isShowDetail ? 'mc-expand' : 'mc-collapse'"
            :disabled="$store.state.video.loadingFleets || isLoadingMore"
            @click="checkDetailVehicleList"
          >
            <i class="mc-fa icon-fill_expand"></i>
            <i class="mc-fa icon-outline_collapse"></i>
          </b-button>
        </div>
      </div>
      <div v-if="!$store.state.video.loadingFleets && !search">
        <div class="mc-trackvision-live-streaming__filter-video-status-wrapper">
          <button
            class="mc-trackvision-live-streaming__btn-filter-video-status"
            :class="{ active: videoStatusShow.online, disabled: isLoadingMore }"
            @click="isLoadingMore ? undefined : handleClickFilterVideoOnline()"
          >
            Video Online ({{ countVideoOnline }})
          </button>
          <button
            class="mc-trackvision-live-streaming__btn-filter-video-status"
            :class="{ active: videoStatusShow.offline, disabled: isLoadingMore }"
            @click="isLoadingMore ? undefined : handleClickFilterVideoOffline()"
          >
            Video Offline ({{ countVideoOffline }})
          </button>
        </div>

        <div
          class="d-flex align-items-center justify-content-between mc-sidebar-liveview__filter-show my-2"
        >
          <div>
            {{ $t('global.fleet') }} :
            <span v-if="countByMotionStatus.moving">
              <strong>{{ countByMotionStatus.moving }}</strong> {{ $t('global.filter.running') }}
            </span>
            <span v-if="countByMotionStatus.idle">
              <strong> {{ countByMotionStatus.idle }}</strong> {{ $t('global.filter.idle') }}
            </span>
            <span v-if="countByMotionStatus.parking">
              <strong> {{ countByMotionStatus.parking }}</strong>
              {{ $t('global.filter.parking') }}
            </span>
            <span v-if="countByMotionStatus.assisted">
              <strong> {{ countByMotionStatus.assisted }}</strong>
              {{ $t('liveView.filter.assisted') }}
            </span>
            <span v-if="countByMotionStatus.offline">
              <strong> {{ countByMotionStatus.offline }}</strong>
              {{ $t('global.filter.offline') }}
            </span>
          </div>
          <div class="d-flex justify-content-end">
            <a href="#" @click="openLegend">
              <i id="legend-info-icon" class="mc-fa icon-outline_info pointer" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="$store.state.video.loadingFleets" class="mc-sidebar--loading">
      <b-spinner label="Loading..." />
    </div>

    <div
      id="list-vehicle-container"
      class="mc-sidebar-liveview__list-fleet mc-sidebar-trackvideo__list-fleet"
      @scroll="handleScroll"
    >
      <b-list-group v-if="!$store.state.video.loadingFleets">
        <template v-if="renderList">
          <FleetItem
            v-for="(row, index) in calculatedVehicleListPagination"
            :ref="`vehicle-streaming-${row.vehicleId}`"
            :key="row.vehicleId"
            :licensePlate="
              row.parent?.vehicle ? row.parent?.vehicle?.licensePlate : row.vehicle.licensePlate
            "
            :hullNo="row.vehicle.hullNo"
            :vehicleCategory="row.vehicle.vehicleType.category"
            :vehicleType="row.vehicle.vehicleType.type"
            :manufacturer="row.vehicle.vehicleType.manufacturer"
            :driver="
              row.parent
                ? row.parent?.vehicle?.driver1?.fullname ?? null
                : row.vehicle.driver1?.fullname ?? null
            "
            :calculatedMotionStatus="
              getVehicleStatusByVehicleId(row.vehicleId).calculatedMotionStatus
            "
            :vehicleId="row.vehicleId"
            :imei="row.vehicle.imei"
            :deviceCode="row.vehicle.device.deviceCode"
            :statusText="row.statusText"
            :engineOn="row.engineOn"
            :lastReceive="row.lastReceive"
            :streamingEndpoint="row.streamingEndpoint"
            :isVideoOnline="!getDeviceIsOffline(row.vehicleId)"
            :isShowDetail="isShowDetail"
            @resetQueryParamsVehicleId="resetQueryParamsVehicleId"
          />
        </template>

        <b-row v-if="isLoadingMore" class="mt-2">
          <b-col cols="12">
            <b-skeleton width="100%" />
          </b-col>
        </b-row>
      </b-list-group>
    </div>

    <button
      class="mc-sidebar-liveview__list-notif-more btn btn-outline-primary"
      @click="goToDownloadVideoHistory"
    >
      <i class="mc-fa icon-outline_download"></i> {{ $t('trackVideo.historyVideoDownload') }}
    </button>
    <LegendLiveStreaming ref="legendComponent" @close="closeLegend" />
    <ModalFilter @acceptFilter="acceptFilter" />
  </div>
</template>

<script>
import { debounce, Helper } from '@/mixin/helper'
import { mapActions, mapGetters, mapState } from 'vuex'
import responsive from '@/mixin/responsive'
import { MixPanel } from '@/mixin/mixpanel'
import WorkerTv2 from 'worker-loader!../lib/worker.js'
import ModalFilter from './ModalFIlter.vue'
import LegendLiveStreaming from '../Legend.vue'
import FleetItem from './FleetItem.vue'

export default {
  name: 'ListFleet',
  components: {
    LegendLiveStreaming,
    ModalFilter,
    FleetItem,
  },
  mixins: [Helper, responsive, MixPanel],
  data() {
    const localStorageFilter = window.localStorage.getItem('filter-live-stream-v2')
    let filterLiveStream = {
      motionStatus: [],
      vehicleId: [],
      videoStatus: [],
    }
    if (localStorageFilter) {
      filterLiveStream = JSON.parse(localStorageFilter)
    }
    const orderByLiveStream = JSON.parse(window.localStorage.getItem('sort-live-stream'))
    const filterMotionStatus = []
    const filterVideoStatus = []
    const filterVehicleId = []
    if (filterLiveStream?.motionStatus.length) {
      filterLiveStream.motionStatus.forEach((val) => {
        filterMotionStatus.push(val)
      })
    }
    if (filterLiveStream?.videoStatus.length) {
      filterLiveStream.videoStatus.forEach((val) => {
        filterVideoStatus.push(val)
      })
    }
    if (filterLiveStream?.vehicleId.length) {
      filterLiveStream.vehicleId.forEach((val) => {
        filterVehicleId.push(val.id)
      })
    }

    const filterActive =
      filterMotionStatus.length || filterVideoStatus.length || filterVehicleId.length
    return {
      search: '',
      orderBy: orderByLiveStream
        ? {
            objName: orderByLiveStream.objName,
            order: orderByLiveStream.order,
          }
        : {
            objName: null,
            order: null,
          },
      orderActive: orderByLiveStream ? Number(orderByLiveStream.orderActive) : null,
      dataByStatus: [],
      sortPopover: false,
      isShowDetail: true,
      renderList: false,
      payloadWsFlespiHowen: null,
      intervalUpdateDataFromWs: null,
      videoStatusShow: {
        online: false,
        offline: false,
      },
      filterActive: filterActive,
      filter: {
        motionStatus: filterMotionStatus,
        videoStatus: filterVideoStatus,
        vehicleId: filterVehicleId,
      },
      paginationState: {
        perPage: 10,
        currentPage: 1,
      },
      isLoadingMore: false,
      wsMessageHandler: null,
    }
  },
  computed: {
    ...mapGetters('video', [
      'fleetsList',
      'tempVehicleStatusByVehicleId',
      'vehicleStatusByVehicleId',
      'flespiHowenVehicleIds',
    ]),
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',

      hasAccess: 'identity/hasAccess',
    }),
    ...mapState('video', ['workerTrackvision']),
    calculatedVehicleListByFilter() {
      let resultData = [...this.dataByStatus]

      if (this.filter.videoStatus.length) {
        resultData = resultData.filter((item) => {
          let show = false
          if (
            this.filter.videoStatus.includes('online') &&
            !this.getDeviceIsOffline(item.vehicleId)
          ) {
            show = true
          }
          if (
            this.filter.videoStatus.includes('offline') &&
            this.getDeviceIsOffline(item.vehicleId)
          ) {
            show = true
          }
          return show
        })
      }
      if (this.filter.motionStatus.length) {
        resultData = resultData.filter((item) => {
          let show = false
          if (
            this.filter.motionStatus.includes('moving') &&
            this.getVehicleStatusByVehicleId(item.vehicleId).calculatedMotionStatus === 'M'
          ) {
            show = true
          }
          if (
            this.filter.motionStatus.includes('idle') &&
            this.getVehicleStatusByVehicleId(item.vehicleId).calculatedMotionStatus === 'I'
          ) {
            show = true
          }
          if (
            this.filter.motionStatus.includes('parking') &&
            this.getVehicleStatusByVehicleId(item.vehicleId).calculatedMotionStatus === 'P'
          ) {
            show = true
          }
          if (
            this.filter.motionStatus.includes('assisted') &&
            this.getVehicleStatusByVehicleId(item.vehicleId).calculatedMotionStatus === 'A'
          ) {
            show = true
          }
          if (
            this.filter.motionStatus.includes('offline') &&
            (this.getVehicleStatusByVehicleId(item.vehicleId).calculatedMotionStatus === 'O' ||
              this.getVehicleStatusByVehicleId(item.vehicleId).calculatedMotionStatus === 'U')
          ) {
            show = true
          }
          return show
        })
      }

      if (this.filter.vehicleId?.length) {
        resultData = resultData.filter((item) => {
          return this.filter.vehicleId.includes(item.vehicleId)
        })
      }

      if (this.search) {
        resultData = resultData.filter((item) => {
          const licensePlate = item.parent?.vehicle
            ? item?.parent?.vehicle?.licensePlate
            : item.vehicle.licensePlate
          const isMatchLicensePlate = licensePlate
            ?.toLowerCase()
            .includes(this.search.toLowerCase())
          const driverFullname = item.parent
            ? item.parent?.vehicle?.driver1?.fullname
            : item.vehicle?.driver1?.fullname
          const isMatchDriverFullname = driverFullname
            ?.toLowerCase()
            .includes(this.search.toLowerCase())
          return isMatchLicensePlate || isMatchDriverFullname
        })
      }

      let sortedVehicle
      if (this.orderActive === null) {
        sortedVehicle = this.getSortedVehiclesDefault(this.dataByStatus)
      } else {
        const tempData = this.dataByStatus
        if (this.orderBy.objName === 'licensePlate') {
          if (this.orderBy.order === 'asc') {
            sortedVehicle = tempData.sort((a, b) => {
              const aLicensePlate = a.parent?.vehicle
                ? a.parent.vehicle.licensePlate
                : a.vehicle.licensePlate

              const bLicensePlate = b.parent?.vehicle
                ? b.parent.vehicle.licensePlate
                : b.vehicle.licensePlate

              return aLicensePlate.localeCompare(bLicensePlate)
            })
          } else if (this.orderBy.order === 'desc') {
            sortedVehicle = tempData.sort((a, b) => {
              const aLicensePlate = a.parent?.vehicle
                ? a.parent.vehicle.licensePlate
                : a.vehicle.licensePlate

              const bLicensePlate = b.parent?.vehicle
                ? b.parent.vehicle.licensePlate
                : b.vehicle.licensePlate

              return bLicensePlate.localeCompare(aLicensePlate)
            })
          }
        } else if (this.orderBy.objName === 'calculatedMotionStatus') {
          if (this.orderBy.order === 'asc') {
            sortedVehicle = this.getSortedVehiclesOrderedByMotionStatus(tempData)
          }
        } else if (this.orderBy.objName === 'videoStatus') {
          if (this.orderBy.order === 'asc') {
            sortedVehicle = this.getSorteVehiclesByVideoStatus(tempData)
          }
        }
      }

      let res = sortedVehicle.filter((item) => {
        let showInList = false
        if (resultData.map((_item) => _item.vehicleId).includes(item.vehicleId)) {
          showInList = true
        }
        return showInList
      })
      return res
    },
    calculatedVehicleListByGroupVideoStatus() {
      const isVideoOnline = this.videoStatusShow.online
      const isVideoOffline = this.videoStatusShow.offline
      const isVideoStatusAll = !isVideoOnline && !isVideoOffline // Assume when all filter not active is filter both online/offline
      let resultData = [...this.calculatedVehicleListByFilter]
      if (!isVideoStatusAll && isVideoOffline) {
        resultData = resultData.filter((item) => {
          return this.getDeviceIsOffline(item.vehicleId)
        })
      }
      if (!isVideoStatusAll && isVideoOnline) {
        resultData = resultData.filter((item) => {
          return !this.getDeviceIsOffline(item.vehicleId)
        })
      }
      return resultData
    },
    calculatedVehicleListPagination() {
      // implement pagination
      const res = this.calculatedVehicleListByGroupVideoStatus.filter((item, index) => {
        if (
          this.$route.query?.vehicleId &&
          item.vehicleId === Number(this.$route.query.vehicleId)
        ) {
          return true
        }
        const itemOrder = index + 1
        if (itemOrder <= this.paginationState.currentPage * this.paginationState.perPage) {
          return true
        }
        return false
      })
      return res
    },

    countVideoOffline() {
      let count = 0
      this.calculatedVehicleListByFilter.forEach((item) => {
        if (this.getDeviceIsOffline(item.vehicleId)) {
          count++
        }
      })
      return count
    },

    countVideoOnline() {
      let count = 0
      this.calculatedVehicleListByFilter.forEach((item) => {
        if (!this.getDeviceIsOffline(item.vehicleId)) {
          count++
        }
      })
      return count
    },

    countByMotionStatus() {
      let moving = 0
      let idle = 0
      let parking = 0
      let assisted = 0
      let offline = 0

      this.calculatedVehicleListByFilter.forEach((item) => {
        if (this.getVehicleStatusByVehicleId(item.vehicleId).calculatedMotionStatus === 'M') {
          moving++
        }
        if (this.getVehicleStatusByVehicleId(item.vehicleId).calculatedMotionStatus === 'I') {
          idle++
        }
        if (this.getVehicleStatusByVehicleId(item.vehicleId).calculatedMotionStatus === 'P') {
          parking++
        }
        if (this.getVehicleStatusByVehicleId(item.vehicleId).calculatedMotionStatus === 'A') {
          assisted++
        }
        if (
          this.getVehicleStatusByVehicleId(item.vehicleId).calculatedMotionStatus === 'U' ||
          this.getVehicleStatusByVehicleId(item.vehicleId).calculatedMotionStatus === 'O'
        ) {
          offline++
        }
      })

      return {
        moving,
        idle,
        parking,
        assisted,
        offline,
      }
    },
    vehicleIds() {
      return this.fleetsList.map((item) => item.vehicleId)
    },
  },
  watch: {
    async '$store.state.video.lastClosedPlaylist'(lastClosedPlaylist) {
      if (lastClosedPlaylist === null) return
      let [vehicleId, _] = lastClosedPlaylist.split(':')
      const componentVehicle = this.$refs[`vehicle-streaming-${vehicleId}`][0]
      componentVehicle.handleClosePlaylist(lastClosedPlaylist)
    },
  },

  async mounted() {
    try {
      this.initWorker()
      await this.loadData()
      await this.setupWebsocket()

      this.intervalUpdateDataFromWs = setInterval(() => {
        if (this.$store.state.ws.socket.isConnected && this.workerTrackvision) {
          this.workerTrackvision.postMessage({
            action: 'calculatedVehicleStatuses',
            tempData: JSON.stringify(this.$store.state.video.tempVehicleStatuses),
            data: JSON.stringify(this.$store.state.video.vehicleStatuses),
          })
        }
      }, 4000)

      if (this.hasAccess(['b3n-trackvision-toggle-video-status:read'])) {
        this.track('Live Streaming List With Video Status', {
          companyId: this.$store.state.identity.whoami?.companyId,
        })
      }

      // TODO : Handle with new code implementation
      // handle autoPlay basedOn queryParams vehicleId
      let vehicleId = this.$route.query.vehicleId
      if (vehicleId) {
        vehicleId = Number(vehicleId)

        if (this.getDeviceIsOffline(vehicleId)) {
          return this.$mcToast.warning(this.$t('notification.text.deviceUnreachable'))
        }

        const componentVehicle = this.$refs[`vehicle-streaming-${vehicleId}`][0]
        await this.delay(1000)
        componentVehicle.handleSelectAllChanel()
      }
    } catch (error) {
      this.$mcToast.error(error?.message ?? this.$t('global.somethingWentWrong'))
      console.log(error)
    }
  },

  beforeDestroy() {
    if (this.wsMessageHandler) {
      this.$store.dispatch('ws/unregisterMessageHandler', this.wsMessageHandler)
    }
  },

  async destroyed() {
    // Terminate the worker when the component is destroyed
    if (this.workerTrackvision) {
      this.workerTrackvision.terminate()
    }
    clearInterval(this.intervalUpdateDataFromWs)
  },
  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },

    ...mapActions('video', ['requestFleetsV2', 'setVehicleTypeAndVgroups']),

    checkIsDemo(vehicleId) {
      const dataDemoTrackvision = this.getFeatureFlagValue('vsms2_trackvision2_stream_demo_id')

      return Object.keys(dataDemoTrackvision)
        .map((id) => parseInt(id))
        .includes(vehicleId)
    },

    getVehicleStatusByVehicleId(vehicleId) {
      if (this.checkIsDemo(vehicleId)) {
        return {
          ...this.vehicleStatusByVehicleId(vehicleId),
          calculatedMotionStatus: 'M',
        }
      }
      return this.vehicleStatusByVehicleId(vehicleId)
    },

    getDeviceIsOffline(vehicleId) {
      if (this.checkIsDemo(vehicleId)) return false

      const secondEngineOn = this.getFeatureFlagValue('trackvision_video_offline_acc_on') || 60,
        secondEngineOff = this.getFeatureFlagValue('trackvision_video_offline_acc_off') || 600,
        lastReceive = this.getVehicleStatusByVehicleId(vehicleId).lastReceive,
        engineOn = this.getVehicleStatusByVehicleId(vehicleId).engineOn

      return this.isDeviceTrackvisionOffline(secondEngineOn, secondEngineOff, lastReceive, engineOn)
    },

    async ensureWebSocketConnected() {
      try {
        const wsToken = localStorage.getItem('wsToken')
        const payload = localStorage.getItem('payload')
        if (!wsToken) return

        // Use centralized WebSocket connection
        // ws/WSConnect already handles all connection logic and waiting
        if (!this.$store.state.ws.socket.isConnected) {
          const wsUrl = `${process.env.VUE_APP_WS_URL}/ws?token=${wsToken}`
          // WSConnect returns a promise that resolves when connected
          // It handles race conditions and waits for ongoing connections automatically
          await this.$store.dispatch('ws/WSConnect', wsUrl)
        }

        // Send payload if connected and not already initialized
        // Only send if App.vue hasn't already sent the initial payload
        if (
          this.$store.state.ws.socket.isConnected &&
          payload &&
          !this.$store.state.ws.isInitialized
        ) {
          this.$store.dispatch('ws/updateTags', payload)
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to ensure WebSocket connection:', error)
      }
    },

    handleWebSocketMessage(message) {
      const signal = typeof message === 'string' ? JSON.parse(message) : message

      if (signal.type.startsWith('gps-')) {
        const vehicleId = Number(signal.type.slice(4))
        if (!this.vehicleIds.includes(vehicleId)) return
        this.calculatedTempWsData(vehicleId, signal.payload)
      }
    },

    async initWorker() {
      if (typeof Worker !== 'undefined') {
        this.$store.commit('video/setWorkerTrackvision', new WorkerTv2())
        await this.$nextTick()
        this.workerTrackvision.onmessage = async (event) => {
          const { action, result } = event.data
          if (action === 'updateVehicleStatuses') {
            this.$store.commit('video/setVehicleStatuses', JSON.parse(result))
            await this.$nextTick()
            this.$store.commit('video/resetTempVehicleStatuses')

            this.$forceUpdate()
          }
        }
      }
    },

    async loadData() {
      this.$store.commit('video/loadingFleets', true)
      this.dataByStatus = []
      this.renderList = false
      await this.requestFleetsV2({
        filter: {
          motionStatus: this.hasAccess(['assisted_motion_status:read'])
            ? ['assisted', 'idle', 'moving', 'offline', 'parking', 'unknown']
            : undefined,
        },
      })

      this.setVehicleStatuses()

      this.dataByStatus = this.fleetsList.map((data) => ({
        ...data,
      }))

      this.setVehicleTypeAndVgroups()

      await this.$nextTick()
      this.renderList = true
      this.$store.commit('video/loadingFleets', false)
    },

    calculatedTempWsData(vehicleId, data) {
      let calculatedMotionStatus = data.calculatedMotionStatus

      if (data.calculatedMotionStatus === 'A' && !this.hasAccess(['assisted_motion_status:read'])) {
        calculatedMotionStatus = 'P'
      }

      this.$store.commit('video/setTempVehicleStatusesByVehicleId', {
        vehicleId,
        data: {
          ...this.tempVehicleStatusByVehicleId(vehicleId),
          lastReceive: data.lastReceive,
          latitude: data.latitude,
          longitude: data.longitude,
          calculatedMotionStatus,
          engineOn: data.engineOn,
        },
      })
    },

    async setupWebsocket() {
      this.wsMessageHandler = this.handleWebSocketMessage.bind(this)
      await this.$store.dispatch('ws/registerMessageHandler', this.wsMessageHandler)

      // Ensure websocket is connected and send payload
      await this.ensureWebSocketConnected()
    },
    setVehicleStatuses() {
      this.fleetsList.forEach((v) => {
        this.$store.commit('video/setVehicleStatusesByVehicleId', {
          vehicleId: v.vehicleId,
          data: {
            calculatedMotionStatus: v.calculatedMotionStatus,
            lastReceive: v.lastReceive,
            engineOn: v.engineOn,
          },
        })
      })
    },

    checkDetailVehicleList() {
      this.isShowDetail = !this.isShowDetail
      if (this.isShowDetail) {
        this.track('Maximize Vehicle List in Track Video')
      } else {
        this.track('Minimize Vehicle List in Track Video')
      }
    },

    async sortBy(objName, order, active) {
      this.orderBy = {
        objName: objName,
        order: order,
      }
      await this.$nextTick()
      if (this.orderActive === active) {
        window.localStorage.setItem('sort-live-stream', JSON.stringify(null))
        this.orderActive = null
      } else {
        window.localStorage.setItem(
          'sort-live-stream',
          JSON.stringify({ ...this.orderBy, orderActive: active })
        )
        this.orderActive = active
      }
      this.sortPopover = !this.sortPopover

      this.track('Sort Vehicle List in Track Video', { sort: order, parameter: objName })

      this.$forceUpdate()
    },

    goToDownloadVideoHistory() {
      const path = window.location.pathname.split('/')
      const isFromMenuTrackvision = path[1] === 'live-streaming'
      this.track('Open Video Download History')
      if (isFromMenuTrackvision) {
        this.$router.push({
          name: 'Video History Trackvision Download',
          query: { prevPage: 'live-streaming' },
        })
      } else {
        this.$router.push({ name: 'Video History 3 Download' })
      }
    },

    // Get channel list without all options
    getChannelList(channel) {
      return channel.filter((item) => item.value !== 'all')
    },

    async openLegend() {
      this.$refs.legendComponent.$refs.legendLiveStreaming.$emit('open')
      await this.$nextTick()
      await this.delay(150)
      document.getElementById('legendLiveStreaming').focus()
    },

    closeLegend() {
      this.$refs.legendComponent.$refs.legendLiveStreaming.$emit('close')
    },

    async handleClickFilterVideoOnline() {
      this.videoStatusShow.online = !this.videoStatusShow.online
      this.videoStatusShow.offline = false
    },

    async handleClickFilterVideoOffline() {
      this.videoStatusShow.offline = !this.videoStatusShow.offline
      this.videoStatusShow.online = false
    },

    getMotionStatusOrder(status) {
      // define motion status order
      const motionStatusOrder = {
        M: 1,
        I: 2,
        P: 3,
        A: 4,
        O: 5,
      }
      return motionStatusOrder[status] || 999
    },

    /**
     * Sort vehicles based on video status, online first
     * @param {Array} vehicles - Array of vehicle objects
     * @returns {Array} - Sorted array of vehicles
     */
    getSorteVehiclesByVideoStatus(vehicles) {
      return [...vehicles].sort((a, b) => {
        // First criterion: Device Online/Offline status (online first)
        const aIsOnline = !this.getDeviceIsOffline(a.vehicleId)
        const bIsOnline = !this.getDeviceIsOffline(b.vehicleId)

        if (aIsOnline !== bIsOnline) {
          return aIsOnline ? -1 : 1 // Online comes first
        }

        // Third criterion: licensePlate alphabetically
        const aLicensePlate = a.parent?.vehicle
          ? a.parent.vehicle.licensePlate
          : a.vehicle.licensePlate
        const bLicensePlate = b.parent?.vehicle
          ? b.parent.vehicle.licensePlate
          : b.vehicle.licensePlate

        return aLicensePlate.localeCompare(bLicensePlate)
      })
    },

    /**
     * Sort vehicles based on motion status
     * @param {Array} vehicles - Array of vehicle objects
     * @returns {Array} - Sorted array of vehicles
     */
    getSortedVehiclesOrderedByMotionStatus(vehicles) {
      return [...vehicles].sort((a, b) => {
        const aStatusOrder = this.getMotionStatusOrder(
          this.getVehicleStatusByVehicleId(a.vehicleId).calculatedMotionStatus
        )
        const bStatusOrder = this.getMotionStatusOrder(
          this.getVehicleStatusByVehicleId(b.vehicleId).calculatedMotionStatus
        )

        if (aStatusOrder !== bStatusOrder) {
          return aStatusOrder - bStatusOrder
        }

        const aLicensePlate = a.parent?.vehicle
          ? a.parent.vehicle.licensePlate
          : a.vehicle.licensePlate
        const bLicensePlate = b.parent?.vehicle
          ? b.parent.vehicle.licensePlate
          : b.vehicle.licensePlate

        return aLicensePlate.localeCompare(bLicensePlate)
      })
    },
    /**
     * Sort vehicles based on online status, motion status, and license plate
     * @param {Array} vehicles - Array of vehicle objects
     * @returns {Array} - Sorted array of vehicles
     */
    getSortedVehiclesDefault(vehicles) {
      return [...vehicles].sort((a, b) => {
        // First criterion: Device Online/Offline status (online first)
        const aIsOnline = !this.getDeviceIsOffline(a.vehicleId)
        const bIsOnline = !this.getDeviceIsOffline(b.vehicleId)

        if (aIsOnline !== bIsOnline) {
          return aIsOnline ? -1 : 1 // Online comes first
        }

        // Second criterion: calculatedMotionStatus order
        const aStatusOrder = this.getMotionStatusOrder(
          this.getVehicleStatusByVehicleId(a.vehicleId).calculatedMotionStatus
        )
        const bStatusOrder = this.getMotionStatusOrder(
          this.getVehicleStatusByVehicleId(b.vehicleId).calculatedMotionStatus
        )

        if (aStatusOrder !== bStatusOrder) {
          return aStatusOrder - bStatusOrder
        }

        // Third criterion: licensePlate alphabetically
        return a.vehicle.licensePlate.localeCompare(b.vehicle.licensePlate)
      })
    },
    handleSearch: debounce(async function (search) {
      this.search = search
    }, 500),
    handleClickFilterLiveStream() {
      this.$bvModal.show('modal-filter-live-streaming')
    },
    clickSort() {},
    async acceptFilter(filter) {
      this.filterActive =
        filter.motionStatus.length || filter.videoStatus.length || filter.vehicleId.length
      this.filter.motionStatus = filter.motionStatus
      this.filter.videoStatus = filter.videoStatus
      this.filter.vehicleId = filter.vehicleId

      await this.$nextTick()
    },

    async handleScroll(event) {
      if (
        this.calculatedVehicleListPagination.length >=
        this.calculatedVehicleListByGroupVideoStatus.length
      )
        return
      if (this.isLoadingMore) return
      const container = event.target
      // Check if we're near the bottom (within 100px)
      const nearBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 100

      if (nearBottom) {
        this.isLoadingMore = true

        this.paginationState.currentPage++
        this.isLoadingMore = false
      }
    },
    resetQueryParamsVehicleId() {
      const vehicleId = this.$route.query.vehicleId
      if (vehicleId) {
        this.$router.replace({
          name: this.$route.name,
          query: {
            ...this.$route.query,
            vehicleId: undefined,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss">
.btn-sort-filter {
  position: relative;
  .badge-active {
    background-color: $red;
    width: 11px;
    height: 11px;
    border-radius: 20px;
    position: absolute;
    top: -4px;
    right: -4px;
    border: 2px solid #fff;
  }
}
</style>
